import React from 'react';
import styled from 'react-emotion';
import MuiAvatar from '@material-ui/core/Avatar';
import theme, { colors } from '@ublend-npm/aulaui-next-web/themes/default';

export const AccordionTitle = styled('span')`
  padding-left: ${theme.spacing.small};
  padding-right: 0;
  color: ${(props) =>
    props.isAddAction
      ? colors.designSystem.blackOpacity87
      : colors.designSystem.marker};
`;

export const Avatar = styled(({ isAddAction, ...props }) => (
  <MuiAvatar {...props} />
))`
  border-radius: 4px;
  font-weight: normal;
  font-family: ${theme.font.family.workSans};
  font-size: ${theme.font.size.copy};
  line-height: ${theme.font.lineHeight.copy};
  background-color: ${(props) =>
    props.isAddAction
      ? colors.designSystem.purple60
      : colors.designSystem.error};
`;
